import { Notifications } from "../../../features/notif&msg/notifications";
import { Dummy } from "../Navbars/components/Dummy";


export function Notify(){

    return(
        <div>
            <Dummy />
            <Notifications />
        </div>
    );
}